import { useState, useEffect, useRef } from 'react';

const POLL_INTERVAL = 5000;
const BACKEND = 'https://lobster-app-sd3s8.ondigitalocean.app';

export function useJobPolling(jobId, token, { onComplete, onError }) {
  const [isPolling, setIsPolling] = useState(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    console.log('useJobPolling useEffect triggered with jobId:', jobId, 'token:', token);

    if (!jobId) {
      console.log('No jobId provided, stopping polling');
      setIsPolling(false);
      return;
    }

    setIsPolling(true);
    console.log('Starting polling for jobId:', jobId);

    intervalRef.current = setInterval(async () => {
      try {
        const response = await fetch(`${BACKEND}/api/job/${jobId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log('Job polling status:', response.status);
        console.log('Job polling headers:', Object.fromEntries(response.headers.entries()));

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();
        console.log('Job polling response:', data);

        if (data.status === 'completed') {
          clearInterval(intervalRef.current);
          setIsPolling(false);
          if (onComplete) onComplete(data.result);
        } else if (data.status === 'failed') {
          clearInterval(intervalRef.current);
          setIsPolling(false);
          if (onError) onError(data.error || 'Job failed');
        } else {
          console.log('Job still pending, continuing polling');
          setIsPolling(true);
        }
      } catch (err) {
        console.error('Polling error:', err);
        clearInterval(intervalRef.current);
        setIsPolling(false);
        if (onError) onError(err.message || 'Polling failed');
      }
    }, POLL_INTERVAL);

    return () => {
      console.log('Cleaning up polling interval for jobId:', jobId);
      clearInterval(intervalRef.current);
      setIsPolling(false);
    };
  }, [jobId, token, onComplete, onError]);

  console.log('useJobPolling returning isPolling:', isPolling);
  return { isPolling };
}